export const specializationCertificateLabel = {
  "": "",
  // "":"",
}

export const additionalCertificatesLabel = {
  "": "",
  // "":"",
}

export const specializationAreaLabel = {
  "67d90056c2c4d5ab747f8b36": "Types of Meditation Taught",
  "67d90056c2c4d5ab747f8b40": "Techniques or Programs Offered",
  "67d90056c2c4d5ab747f8b3b": "Techniques Specialized In",
  "67d90056c2c4d5ab747f8b3c": "Time Management Techniques",
  "67d90056c2c4d5ab747f8b35": "Yoga Styles Offered",
  "67d90056c2c4d5ab747f8b39": "Areas of Expertise",
  "67d90056c2c4d5ab747f8b34": "Coaching Specialties",
  "67d90056c2c4d5ab747f8b3f": "Areas of Expertise",
  "": "",
  // "":"",
}

export const trainingBackgroundLabel = {
  "67d90056c2c4d5ab747f8b36": "Meditation Training Background",
  "67d90056c2c4d5ab747f8b41": "Training in Spiritual Advisor techniques",
  "67d90056c2c4d5ab747f8b3c": "Training in Techniques",
  "67d90056c2c4d5ab747f8b3e": "Training in Art Therapy",
  "67d90056c2c4d5ab747f8b3d": "Training in Holistic Practices",
  "": "",
  // "":"",
}

export const experienceLabel = {
  "67d90056c2c4d5ab747f8b36": "Teaching Experience",
  "67d90056c2c4d5ab747f8b35": "Teaching Experience",
  "": "",
  // "":"",
}

export const specializationAreaDescriptionLabel = {
  "": "",
  // "":"",
}